<div class="flex justify-between items-center py-3 border-b border-neutral-300 max-w-screen-sm">
  <div class="mr-2 flex-1">
    <p
      *ngIf="!translate"
      class="text-sm leading-4.5 lg:text-base"
      [style.color]="textColor | contentBuilderColor"
    >
      {{ text }}
    </p>
    <p *ngIf="translate">{{ text | translate }}</p>
  </div>
  <div class="flex flex-row justify-center items-center">
    <div
      class="icon {{ icon }} pl-4"
      [style.color]="secondaryTextColor | contentBuilderColor"
    ></div>
    <div class="text-sm w-20 leading-5 text-right">
      <app-price-atom
        [bold]="false"
        [amount]="price"
        [format]="true"
      ></app-price-atom>
    </div>
  </div>
</div>
